import type { ReactNode } from "react";
import { Icon } from "./Icon";

export function ActionRow({ children, onClick, icon }: { children: ReactNode; onClick?: () => void; icon?: "external" | "document" }) {
  return (
    <button type="button" className="action-row" onClick={onClick}>
      {icon ? <Icon name={icon} size={22} /> : null}
      <span>{children}</span>
      <Icon name="chevron" size={22} />
    </button>
  );
}
